module.exports = __webpack_public_path__ + "static/media/pick11-cricketplayer@2x.4b5ccaba.png";